import getConnections from '../../redux/axios/websocketProxy/getConnections'
import { internalApiUrl } from '../../urls'
import { logger } from '../../logger/logger'

export const LEGACY_SOCKET_ENDPOINT = { url: internalApiUrl, path: '/websocketproxy/socket.io' }

const parseEndpointAnswer = (response) => {
	const endpoint = response.data
	if (!endpoint?.url || !endpoint?.path) {
		return null
	}

	return endpoint
}

export const resolveSocketEndpoint = () =>
	getConnections()
		.then((response) => {
			const endpoint = parseEndpointAnswer(response)
			if (!endpoint) {
				logger.warn('[socket-io] Endpoint lookup returned a malformed answer, using the legacy endpoint')

				return LEGACY_SOCKET_ENDPOINT
			}

			return endpoint
		})
		.catch(() => {
			logger.warn('[socket-io] Endpoint lookup failed, using the legacy endpoint')

			return LEGACY_SOCKET_ENDPOINT
		})
